import source from "../downloaded/char2trainingCompletionTierCount.json" assert { type: 'json' };

export const trainingCompletionTierCount = {}

for (const row of source) {
  const { statTier, trainingCount } = row
  trainingCompletionTierCount[statTier] = trainingCount
}
